import {FC} from 'react';

import {useIsFocused} from '../../../../libs/shared/ui/src/hooks/focusHookHelpers';
import {HandoffActivityTypesEnum, RestorationData} from '../../../../srcCommon/app/handoff/handoffModel';
import {useDesktopUserActivity} from './desktopUserActivityHooks';

/*
 * Props.
 */

interface UserActivityProps<T extends HandoffActivityTypesEnum> {
  type: T;
  userInfo: RestorationData<T>;
  isActive?: boolean;
}

/*
 * Component.
 */

export const UserActivity = <T extends HandoffActivityTypesEnum>(
  props: UserActivityProps<T>,
): ReturnType<FC> => {
  const {type, userInfo, isActive = true} = props;
  const isFocused = useIsFocused();
  useDesktopUserActivity(type, userInfo, !(isFocused && isActive));
  return null;
};
